import SkeletonComponent from '@atoms/SkeletonComponent';
import PhoneEmptyView from '@molecules/PhoneEmptyView';
import PhoneList from '@molecules/PhoneList';
import React from 'react';

interface PhoneItem {
  // Define the shape of your phone items here
  id?: string;
  phoneNumber?: string;
  // Add other phone item properties as needed
}

interface PhoneListOrEmptyViewProps {
  loading?: boolean;
  phoneList?: PhoneItem[];
  getPhoneNumbers?: () => void;
  isTransact?: boolean;
  transactionCategoryId?: string;
}

const PhoneListOrEmptyView = ({
  loading = false,
  phoneList = [],
  getPhoneNumbers = () => {},
  isTransact = false,
  transactionCategoryId = '',
}: PhoneListOrEmptyViewProps) => {
  if (loading) {
    return <SkeletonComponent />;
  }

  if (!phoneList || phoneList.length === 0) {
    return <PhoneEmptyView isTransact={isTransact} transactionCategoryId={transactionCategoryId} />;
  }

  return (
    <PhoneList
      phoneList={phoneList}
      getPhoneNumbers={getPhoneNumbers}
      isTransact={isTransact}
      transactionCategoryId={transactionCategoryId}
    />
  );
};

export default PhoneListOrEmptyView;
